/* eslint-disable prettier/prettier */
import React from 'react';

import dayjs from 'dayjs';
import SelectMethodModal from './SelectMethodModal';
import useSWR from 'swr';
import { useSelector, State } from '@medlinker/fundamental';

import * as hosts from '../../constants/hosts';
import request from '../../request';
import { Toast } from '../../components';
import { track } from '../../utils/EventTracker';

interface Props {
  doctorId: number;
  transNo?: number;
  from: 'chatRoom' | 'prescriptionList' | 'orderList' | 'home' | 'orderDetail';
  fromBtnText: string;
  children: React.ReactElement;
}

export default function ChooseDrugBuyMethodAB(props: Props) {
  const userInfo = useSelector((state: State) => state.user);

  const { data: firstId } = useSWR(
    props.transNo
      ? null
      : [
        '/prescription-interface/v1/prescription/electronic/con-continue/list',
        props.doctorId,
      ],
    async ([url, doctorId]) => {
      try {
        const res = await request.get<any, any>(url, {
          baseURL: hosts.GENERAL,
          params: {
            limit: 1,
            start: 0,
            doctorId,
          },
        });

        const id = res.list?.[0]?.electronic.id;

        return id;
      } catch (error) {
        Toast.info(error.message);
      }
    },
    {
      refreshInterval: 0,
      revalidateOnFocus: false,
    }
  );

  // 查询是否购买了复购问诊
  const { data: { isPay = false, payPrice } = {} } = useSWR(
    [
      `${hosts.API}/followup-interface/v1/chat/detail`,
      { doctorId: props.doctorId },
    ],
    async ([url, params]) => {
      const res = await request.get<
        any,
        { chatType: 1 | 2; deadline: number; payPrice: number }
      >(url, {
        params: {
          ...params,
          isReConsultation: true,
        },
      });

      return {
        isPay: res.deadline > 0 && res.chatType === 2,
        payPrice: res.payPrice,
      };
    },
    {
      refreshInterval: 0,
      revalidateOnFocus: false,
    }
  );

  const transNo = React.useMemo(() => {
    return props.transNo ?? firstId ?? 0;
  }, [props.transNo, firstId]);

  const [open, setOpen] = React.useState(false);

  return (
    <>
      <SelectMethodModal
        doctorId={props.doctorId}
        transNo={transNo}
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        tapMaskClose
        isPay={isPay}
        payPrice={payPrice ?? 0}
      />

      {React.cloneElement(props.children, {
        onClick(e: MouseEvent) {

          if (!transNo) {
            Toast.info(
              '抱歉，您当前未有满足续方条件的处方，您可以在交流中请医生为您开具处方'
            );

            return;
          }

          // 患者端点击复购按钮
          if (userInfo?.info?.base?.userId) {
            track('fe_patient_repurchase_btn_click', {
              ab_hit_result: '', // 标记是试验组还是对照组
              patient_id: `${userInfo.info.base.userId}`,
              into_ab_app_id: '',
              into_ab_exp_id: '',
              click_at: dayjs().format('YYYY-MM-DD HH:mm:ss'),
              click_result: '成功',
              click_btn_title: props.fromBtnText,
              click_inpage_flag: props.from,
            });
          }
          setOpen(true);
        },
      })}
    </>
  );
}
